import * as React from 'react';
import { RouteObject } from 'react-router-dom';

// Components
import { AdminRouteWrapper } from '../../components/AdminRouteWrapper';

// Sub-routes
import { AdminClientsRoutes } from './children/Clients';
import { AdminContactsRoutes } from './children/Contacts';
import { AdminExportRoutes } from './children/Export';
import { AdminSettingsRoutes } from './children/Settings';
import { AdminSurveysRoutes } from './children/Surveys';
import { AdminUserRoutes } from './children/Users';
import { AdminReportsRoutes } from './children/Reports';
import { AdminLoansRoutes } from './children/Loans';

const AdminDashboard = React.lazy(
    () => import(/* webpackChunkName: "admin-dashboard" */ '../../containers/Admin/Dashboard')
);

export const AdminRoutes: RouteObject[] = [
    {
        element: <AdminRouteWrapper />,
        children: [
            {
                index: true,
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <AdminDashboard />
                    </React.Suspense>
                )
            },
            AdminClientsRoutes,
            AdminContactsRoutes,
            AdminExportRoutes,
            AdminLoansRoutes,
            AdminReportsRoutes,
            AdminSettingsRoutes,
            AdminSurveysRoutes,
            AdminUserRoutes
        ]
    }
];
